import React from 'react';
import './LoadingDots.css';

export const LoadingDots = () => (
  <div className="loadingDotContainer">
    <div className="loadingDot" />
    <div className="loadingDot" />
    <div className="loadingDot" />
  </div>
);
